import { Check } from "lucide-react";
import { valueStack, normalPrice, site } from "@/config/site.config";

export const ValueStack = ({ dark = false }) => {
  const parse = (v) => Number(String(v).replace(/[^0-9.]/g, "")) || 0;
  const itemized = valueStack.filter((i) => i.value);
  const computedTotal = itemized.reduce((s, i) => s + parse(i.value), 0);
  const total = normalPrice || (computedTotal ? `$${computedTotal.toLocaleString("en-US")}` : "");
  if (!total) return null;

  return (
    <div data-testid="value-stack" className={`mt-10 text-left ${dark ? "text-ink" : "text-cream"}`}>
      <p className="text-center font-mono text-[10px] tracking-[0.35em] opacity-60">EVERYTHING INCLUDED</p>
      <ul className="mt-4 space-y-2.5">
        {valueStack.map((i) => (
          <li key={i.label} className="flex items-baseline justify-between gap-4 text-sm">
            <span className="flex items-start gap-2 font-semibold">
              <Check className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={3} />
              {i.label}
            </span>
            {i.value && <span className="shrink-0 font-mono text-xs line-through opacity-60">{i.value}</span>}
          </li>
        ))}
      </ul>
      <div className="mt-5 flex items-baseline justify-between border-t border-current/20 pt-4">
        <span className="font-mono text-[11px] tracking-[0.3em]">NORMALLY</span>
        <span className="font-serif text-3xl font-bold line-through opacity-70">{total}</span>
      </div>
      <p className="mt-1 text-right font-mono text-[11px] tracking-[0.3em]">
        TODAY: <span className="font-bold">{site.price}</span>
      </p>
    </div>
  );
};
